"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/* eslint-disable react-hooks/exhaustive-deps */

const useStationTowns = _ref => {
  let {
    sortArr,
    stationStops,
    whitelist
  } = _ref;
  const [towns, setTowns] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    var _stationStops$map$fil, _ref2;
    if (stationStops.length === 0) return;
    const filterUniqueTowns = (_stationStops$map$fil = stationStops.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index && value !== "")) === null || _stationStops$map$fil === void 0 ? void 0 : _stationStops$map$fil.filter(town => {
      // show only towns in whitelist

      if (whitelist.length === 0) {
        return town;
      }

      // check if town is in whitelist

      return whitelist.indexOf(town) > -1;
    });
    const sortTowns = [];
    const unsortTowns = [];
    filterUniqueTowns === null || filterUniqueTowns === void 0 || filterUniqueTowns.forEach(town => {
      // search index in sortArr

      const index = sortArr.indexOf(town);
      if (index > -1) {
        sortTowns[index] = town;
      } else {
        unsortTowns.push(town);
      }
    });
    const combinedTowns = (_ref2 = [...sortTowns, ...unsortTowns]) === null || _ref2 === void 0 ? void 0 : _ref2.filter(n => n);
    setTowns(combinedTowns);
  }, [stationStops.length, sortArr]);
  return towns;
};
var _default = exports.default = useStationTowns;